import Image from "next/image";

import avatar from "@/public/winwingpt/growin.png";

export const AvatarImage = () => (
  <Image src={avatar} alt="avatar" className="h-10 w-10 rounded-full" />
);
